class TopBanner {
  constructor() {
    this.selectors = {
      banner: '[data-top-banner]',
      carousel: '[data-top-banner-messages]',
      track: '[data-top-banner-track]',
      message: '.top-banner__message',
    };
    this.slideHeight = 32;
    this.delay = 5000;
    this.carouselState = new WeakMap();

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', () => this.init())
      : this.init();
  }

  init() {
    this.initBanner();
  }

  initBanner() {
    const banner = document.querySelector(this.selectors.banner);
    if (!banner) return;

    this.initCarousel(banner);
    this.bindBannerClicks(banner);
  }

  destroyCarousel(carousel) {
    const state = this.carouselState.get(carousel);
    if (!state) return;

    if (state.timer) window.clearInterval(state.timer);
    if (state.onTransitionEnd) state.track.removeEventListener('transitionend', state.onTransitionEnd);
    if (state.clone) state.clone.remove();
    if (state.onMouseEnter) carousel.removeEventListener('mouseenter', state.onMouseEnter);
    if (state.onMouseLeave) carousel.removeEventListener('mouseleave', state.onMouseLeave);

    state.track.classList.remove('top-banner__track--instant');
    state.track.style.transform = '';
    this.carouselState.delete(carousel);
  }

  initCarousel(container) {
    const carousel = container.querySelector(this.selectors.carousel);
    const track = carousel?.querySelector(this.selectors.track);
    if (!carousel || !track) return;

    this.destroyCarousel(carousel);

    const slides = [...track.querySelectorAll(this.selectors.message)];
    if (slides.length <= 1) return;

    const clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.dataset.clone = 'true';
    track.appendChild(clone);

    const state = {
      track,
      index: 0,
      total: slides.length,
      timer: null,
      paused: false,
      clone,
      onTransitionEnd: null,
      onMouseEnter: null,
      onMouseLeave: null,
    };

    const setPosition = (index, instant) => {
      if (instant) track.classList.add('top-banner__track--instant');
      track.style.transform = 'translate3d(0, ' + (-index * this.slideHeight) + 'px, 0)';
      if (instant) {
        track.offsetHeight;
        track.classList.remove('top-banner__track--instant');
      }
    };

    const next = () => {
      if (state.paused) return;

      state.index += 1;
      setPosition(state.index, false);

      if (state.index < state.total) return;

      if (state.onTransitionEnd) track.removeEventListener('transitionend', state.onTransitionEnd);

      state.onTransitionEnd = (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        track.removeEventListener('transitionend', state.onTransitionEnd);
        state.onTransitionEnd = null;
        state.index = 0;
        setPosition(0, true);
      };

      track.addEventListener('transitionend', state.onTransitionEnd);
    };

    const startTimer = () => {
      if (state.timer) window.clearInterval(state.timer);
      state.timer = window.setInterval(next, this.delay);
    };

    state.onMouseEnter = () => {
      state.paused = true;
      if (state.timer) window.clearInterval(state.timer);
    };

    state.onMouseLeave = () => {
      state.paused = false;
      startTimer();
    };

    carousel.addEventListener('mouseenter', state.onMouseEnter);
    carousel.addEventListener('mouseleave', state.onMouseLeave);

    this.carouselState.set(carousel, state);
    setPosition(0, true);
    startTimer();
  }

  bindBannerClicks(banner) {
    const handleBannerAction = (e) => {
      const target = e.target;

      if (target.closest('.promo-link, a')) return;

      const clickedMessage = target.closest('[data-message]');
      const messageId = clickedMessage?.dataset?.message;

      if (messageId === 'discount') {
        e.preventDefault();
        e.stopPropagation();
        if (window.openNewsletterPopup) {
          window.openNewsletterPopup();
        } else {
          this.openRegistrationPopup();
        }
      }
    };

    banner.addEventListener('click', handleBannerAction);
    banner.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      handleBannerAction(e);
    }, true);
  }

  openRegistrationPopup() {
    if (window.openRegistrationPopup) return window.openRegistrationPopup();

    const popup = document.getElementById('registration-discount-popup');
    if (!popup) return;

    popup.style.display = 'flex';
    window.themeScrollLock?.lock?.();

    requestAnimationFrame(() => popup.classList.add('show'));
  }
}

if (!window.topBannerInstance) window.topBannerInstance = new TopBanner();
document.addEventListener('shopify:section:load', () => window.topBannerInstance.initBanner());
